"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Hidden = _interopRequireDefault(require("@mui/material/Hidden"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _excluded = ["className", "children"],
  _excluded2 = ["className", "children"],
  _excluded3 = ["className", "children"],
  _excluded4 = ["headingCopy", "subheadingCopy", "imagesArray"],
  _excluded5 = ["node"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    hsub: true,
    gray: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var CommunityImage = _styledComponents.default.img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  height: 300px;\n  width: 300px !important;\n  margin: auto;\n  background-size: cover;\n  object-fit: cover;\n  object-position: top;\n\n  @media (min-width: ", ") {\n    height: 350px;\n    width: 350px !important;\n  }\n  \n  @media (min-width: ", ") {\n    height: 525px;\n    width: 525px !important;\n  }\n\n  @media (min-width: ", ") {\n    height: 625px;\n    width: 625px !important;\n  }\n  @media (min-width: ", ") {\n    height: 725px;\n    width: 725px !important;\n  }\n  @media (min-width: ", ") {\n    height: 825px;\n    width: 825px !important;\n  }\n"])), _bfBaseStyles.Breakpoints.xs, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l, _bfBaseStyles.Breakpoints.xl);
var MobileCarousel = (0, _styledComponents.default)(function (_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_nukaCarousel.default, {
    defaultControlsConfig: {
      nextButtonText: '>',
      prevButtonText: '<'
    },
    slidesToShow: 1.1,
    cellAlign: 'center',
    framePadding: '0px 20px',
    className: className
  }, children);
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var TabletCarousel = (0, _styledComponents.default)(function (_ref4) {
  var className = _ref4.className,
    children = _ref4.children,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  return _react.default.createElement(_nukaCarousel.default, {
    defaultControlsConfig: {
      nextButtonText: '>',
      prevButtonText: '<'
    },
    slidesToShow: 1.3,
    cellAlign: 'center',
    framePadding: '0px 20px',
    className: className
  }, children);
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var DesktopCarousel = (0, _styledComponents.default)(function (_ref5) {
  var className = _ref5.className,
    children = _ref5.children,
    props = (0, _objectWithoutProperties2.default)(_ref5, _excluded3);
  return _react.default.createElement(_nukaCarousel.default, {
    defaultControlsConfig: {
      nextButtonText: '>',
      prevButtonText: '<'
    },
    slidesToShow: 1.4,
    cellAlign: 'center',
    framePadding: '0px 20px',
    className: className
  }, children);
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var OurCommunity = function OurCommunity(_ref6) {
  var headingCopy = _ref6.headingCopy,
    subheadingCopy = _ref6.subheadingCopy,
    imagesArray = _ref6.imagesArray,
    props = (0, _objectWithoutProperties2.default)(_ref6, _excluded4);
  return _react.default.createElement(_PageGrid.default, props, _react.default.createElement(StyledSectionHeading, null, " ", headingCopy, " "), _react.default.createElement(_reactMarkdown.default, {
    children: subheadingCopy,
    components: {
      p: function p(_ref7) {
        var node = _ref7.node,
          props = (0, _objectWithoutProperties2.default)(_ref7, _excluded5);
        return _react.default.createElement(StyledSectionSubheading, props);
      }
    }
  }), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: "center"
  }, props), _react.default.createElement(_Hidden.default, {
    mdUp: true
  }, _react.default.createElement(MobileCarousel, null, imagesArray.map(function (imageItem) {
    return _react.default.createElement(CommunityImage, {
      src: imageItem.data.attachments[0].url,
      alt: imageItem.data.alt_text
    });
  }))), _react.default.createElement(_Hidden.default, {
    only: ['xs', 'sm', 'lg', 'xl']
  }, _react.default.createElement(TabletCarousel, null, imagesArray.map(function (imageItem) {
    return _react.default.createElement(CommunityImage, {
      src: imageItem.data.attachments[0].url,
      alt: imageItem.data.alt_text
    });
  }))), _react.default.createElement(_Hidden.default, {
    xlDown: true
  }, _react.default.createElement(DesktopCarousel, null, imagesArray.map(function (imageItem) {
    return _react.default.createElement(CommunityImage, {
      src: imageItem.data.attachments[0].url,
      alt: imageItem.data.alt_text
    });
  })))));
};
var _default = OurCommunity;
exports.default = _default;